import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface LoginForm {
  email: string;
  password: string;
}

const LoginPage: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnUrl = searchParams.get('returnUrl');
  const [error, setError] = useState<string | null>(null);
  const [showPassword, setShowPassword] = useState(false);
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm<LoginForm>();

  const onSubmit = async (data: LoginForm) => {
    setError(null);
    try {
      await login(data.email, data.password);
      navigate(returnUrl || '/', { replace: true });
    } catch (err: any) {
      setError(err.message || 'Login failed');
    }
  };

  return (
    <div className="main-content">
      <div className="auth-page">
        <div className="form-container auth-form-container">
          <h2>Log In</h2>
          {error && <p className="auth-error">{error}</p>}
          <form onSubmit={handleSubmit(onSubmit)} className="admin-form">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                className={errors.email ? 'error' : ''}
                {...register('email', { required: 'Email is required' })}
              />
              {errors.email && <span className="error-text">{errors.email.message}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className="password-input-wrapper">
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  className={errors.password ? 'error' : ''}
                  {...register('password', { required: 'Password is required' })}
                />
                <button
                  type="button"
                  className="password-toggle-btn"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                >
                  {showPassword ? 'Hide' : 'Show'}
                </button>
              </div>
              {errors.password && <span className="error-text">{errors.password.message}</span>}
            </div>
            <div className="form-actions">
              <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                {isSubmitting ? 'Logging in...' : 'Log In'}
              </button>
            </div>
          </form>
          <div className="auth-links">
            <p>Don't have an account? <Link to={returnUrl ? `/signup?returnUrl=${encodeURIComponent(returnUrl)}` : '/signup'}>Sign up</Link></p>
            <p><Link to={returnUrl ? `/forgot-password?returnUrl=${encodeURIComponent(returnUrl)}` : '/forgot-password'}>Forgot password?</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
